import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photosOneTimeCleanups } from "../../../script";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllProjects.css";

export default function OneTimeCleanup() {
  
  const location = useLocation();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "One Time Cleanups Project | BUR-HAN Garden & Lawn Care";
    document.title = newTitle;

    const newDescription =
    "Discover our upcoming One Time Cleanups projects and learn how we can enhance your outdoor space with our expert One Time Cleanups installations. Stay tuned for high-quality One Time Cleanups services designed to elevate your property.";
    const descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
  "one-time cleanup Vancouver",
  "garden overhaul Vancouver",
  "yard cleanup projects",
  "seasonal property cleanups",
  "before and after yard transformations",
  "landscape restoration projects BC",
  "residential garden reclaiming",
  "property maintenance examples"    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <div className="wrapper">
      <Header />

      <div className="projectsGalleryHeader">
        <h1 data-aos="zoom-in"> One Time Cleanups </h1>
      </div>
      <div className="projectsGalleryMain" data-aos="fade-up">
       
        <h2 className="text-center">
          {" "}
          <a href="/services/hardscape-installs-maintenance">
            Click here to learn more about our services{" "}
          </a>{" "}
        </h2>
        <hr />
        <a href="/our-projects" className="to-top">
          Back to projects
        </a>

        <div className="gallery">
          <Gallery photos={photosOneTimeCleanups} onClick={openLightbox} />
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photosOneTimeCleanups.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                    alt: x.alt,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
        <section className="project-text" data-aos="fade-up">
          <div className="container">
            <h2>One-Time Garden Cleanup Services in Vancouver</h2>
            <p>
              Is your yard overgrown, neglected, or simply in need of a fresh
              start? <strong>BUR-HAN Garden & Lawn Care</strong> offers
              professional <strong>one-time garden cleanup services</strong>{" "}
              across Vancouver, North Vancouver, West Vancouver, Burnaby, and
              the surrounding Lower Mainland. Whether it's a spring cleanup
              after winter, a fall yard cleanup before the rains arrive, or a
              full property overhaul for a home sale or renovation, our team
              gets the job done efficiently and thoroughly.
            </p>
            <p>
              Our one-time cleanup service covers everything your yard needs to
              look its best: removing dead plants and debris, cutting back
              overgrown shrubs and hedges, clearing out weeds, blowing and
              bagging leaves, edging lawn borders, and hauling away all green
              waste. We work quickly and leave your property clean, tidy, and
              ready to enjoy — or to hand off to a new owner.
            </p>
            <p>
              Many of our clients in North Vancouver and West Vancouver book a
              one-time cleanup as a starting point before enrolling in a regular
              garden maintenance program. It's also a popular choice for
              homeowners preparing to list a property, landlords turning over a
              rental, and strata managers dealing with a seasonal backlog.
            </p>
            <p>
              Browse the before-and-after photos in the gallery above to see
              the difference a professional one-time cleanup can make. Ready to
              reclaim your outdoor space?{" "}
              <a href="/contact-us">Contact BUR-HAN</a> to book your cleanup
              today.
            </p>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-8 ">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our Get a Quote page, and let our expert landscaping
                  team bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs. Contact us today to get a personalized landscaping plan tailored to your needs. Your dream garden is just one step away.
                </p>
              </div>
              <div className="col-md-4 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Get A Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
